import Reveal from '@/components/base/Reveal';
import { heroStats } from '@/mocks/home';

export default function Hero() {
  return (
    <section id="top" className="relative w-full bg-background-50 pt-28 md:pt-36 pb-14 md:pb-20">
      <div className="w-full px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14 items-center">
          <Reveal className="order-2 lg:order-1">
            <div className="inline-flex items-center gap-2 rounded-full border border-accent-200 bg-accent-50 px-3 py-1.5">
              <span className="w-2 h-2 rounded-full bg-accent-500"></span>
              <span className="text-xs md:text-sm text-accent-700 tracking-wide">亲历者档案 · 真实讲述 · 持续更新</span>
            </div>

            <h2 className="mt-5 font-heading text-3xl md:text-4xl lg:text-[44px] leading-[1.25] font-bold text-foreground-950">
              从高薪招工到失去自由，
              <br className="hidden sm:block" />
              他们的口述值得被听见
            </h2>

            <p className="mt-5 text-sm md:text-base leading-7 md:leading-8 text-foreground-600 max-w-xl">
              这里收录<strong className="font-semibold text-foreground-900">缅北黑料亲历者</strong>与
              <strong className="font-semibold text-foreground-900">缅北黑料受害者</strong>的讲述、经历与口述自述，
              还原被困细节与逃生过程，用真实故事警示更多人远离骗局。
            </p>

            <div className="mt-7 flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
              <a
                href="#timeline"
                className="inline-flex items-center justify-center gap-2 h-12 px-6 rounded-md bg-primary-500 text-background-50 text-sm md:text-base font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-mic-line text-lg"></i>
                浏览亲历者口述
              </a>
              <a
                href="#entry"
                className="inline-flex items-center justify-center gap-2 h-12 px-6 rounded-md border border-foreground-300 text-foreground-900 text-sm md:text-base font-medium hover:border-primary-400 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-compass-3-line text-lg"></i>
                进入资源入口
              </a>
            </div>

            <div className="mt-9 grid grid-cols-3 gap-4 border-t border-background-200 pt-6">
              {heroStats.map((stat) => (
                <div key={stat.label}>
                  <div className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">{stat.value}</div>
                  <div className="mt-1 text-xs md:text-sm text-foreground-500 leading-5">{stat.label}</div>
                </div>
              ))}
            </div>
          </Reveal>

          <Reveal className="order-1 lg:order-2" delay={120}>
            <div className="relative">
              <div className="w-full h-[300px] sm:h-[380px] lg:h-[540px] rounded-lg overflow-hidden border border-background-200 bg-background-100">
                <img
                  src="https://readdy.ai/api/search-image?query=Stylized%20misty%20mountain%20ranges%20at%20dusk%20with%20layers%20of%20fog%20over%20forested%20hilltops%2C%20muted%20warm%20brown%20amber%20and%20clay%20tones%2C%20atmospheric%20documentary%20landscape%20painting%2C%20soft%20film%20grain%2C%20no%20people%2C%20calm%20solemn%20restrained%20mood&width=900&height=1100&seq=mnhl-hero-01&orientation=portrait"
                  alt="缅北黑料亲历者口述档案 主题氛围图"
                  title="缅北黑料 亲历者讲述 受害者口述自述"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="hidden md:block absolute -bottom-6 -left-6 w-56 rounded-lg bg-background-50 border border-background-200 p-4">
                <div className="flex items-center gap-2 text-accent-600">
                  <i className="ri-double-quotes-l"></i>
                  <span className="text-xs tracking-wide">口述摘录</span>
                </div>
                <p className="mt-2 text-xs leading-6 text-foreground-600">
                  “落地那一刻，我才知道所谓的高薪，是拿自由去换的。”
                </p>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}